import './delete-license-modal.scss'; //
import {} from '@converge/data';

import { Box, Stack } from '@mui/material';

import { DialogLayout } from '../../../../presentation';
import { NewConvergeButton } from '../../../../presentation/components/new-button';

interface AddLicenseModalProps {
  onClose: () => void;
  title: string;
  DeleteHandler: () => void;
  submitLabel: string;
  context: string;
  loading: boolean;
}

export const DeleteLicenseModal = ({
  onClose,
  title,
  DeleteHandler,
  context,
  submitLabel,
  loading,
}: AddLicenseModalProps) => {
  return (
    <DialogLayout
      data-testid="delete-license-modal"
      open
      onClose={onClose}
      showCloseButton={true}
      onCloseIconClick={onClose}
      header={<Box className="modal-title-delete"> {title}</Box>}
    >
      <Stack className="content-message-license">{context}</Stack>
      <Stack className="modal-btn-container-message-license">
        <Box style={{ marginRight: '15px' }}>
          <NewConvergeButton
            label="CANCEL"
            variant="outlined"
            onClick={() => {
              onClose();
            }}
          />
        </Box>
        <Box>
          <NewConvergeButton
            label={submitLabel}
            loading={loading}
            onClick={() => DeleteHandler()}
          />
        </Box>
      </Stack>
    </DialogLayout>
  );
};
